import React, { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import Stats from "@/components/sections/Stats";
import Businesses from "@/components/sections/Businesses";
import Journey from "@/components/sections/Journey";
import Focus from "@/components/sections/Focus";
import People from "@/components/sections/People";
import Partner from "@/components/sections/Partner";
import FinalCta from "@/components/sections/FinalCta";
import Footer from "@/components/sections/Footer";

export default function Landing() {
  useEffect(() => {
    document.title = "DSS — Dynamic Strategic Solutions";
  }, []);

  return (
    <main data-testid="landing-page" className="bg-ash">
      <Navbar />
      <Hero />
      <Stats />
      <Businesses />
      <Journey />
      <Focus />
      <People />
      <Partner />
      <FinalCta />
      <Footer />
    </main>
  );
}
